var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRainbow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.8 73.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ef4b24;}.cls-2{fill:#5e54a4;}.cls-3{fill:#26a5de;}.cls-4{fill:#73bf45;}.cls-5{fill:#e8d91b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.8,8.9V0C33.11,0,0,33.11,0,73.8H8.9C8.9,38.02,38.02,8.9,73.8,8.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8.9,73.8h8.9c0-30.88,25.12-56,56-56V8.9C38.02,8.9,8.9,38.02,8.9,73.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17.8,73.8h8.9c0-25.97,21.13-47.1,47.1-47.1v-8.9c-30.88,0-56,25.12-56,56Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.7,73.8h8.9c0-21.07,17.14-38.2,38.2-38.2v-8.9c-25.97,0-47.1,21.13-47.1,47.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.8,40.05v-4.45c-21.07,0-38.2,17.14-38.2,38.2h8.9c0-16.16,13.15-29.3,29.3-29.3v-4.45c-18.64,0-33.75,15.11-33.75,33.75h0c0-18.64,15.11-33.75,33.75-33.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainbow);
export default __webpack_public_path__ + "static/media/rainbow.5952d42d00dd2e46483f61f271bf9f7a.svg";
export { ForwardRef as ReactComponent };